// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39s9e","placeholdersHeader":"styles_placeholdersHeader__2dI0I","editorStyle":"styles_editorStyle__6cQp2","placeholdersBox":"styles_placeholdersBox__2HkZz"};